import React, {ReactNode, useContext, useState} from 'react';
import spinner from './pokeball_gray.png'
import './loading-spinner.css'
import { useTranslation } from 'react-i18next'

export type LoadingSpinnerProps = {
  /**
   * alt text for spinner.
   */
  altText?: string;
  /**
    * a node to be rendered in the component when the Loading Spinner is not shown.
    */
  children?: ReactNode
};

export type LoadingProviderProps = {
  children: ReactNode
}

export type LoadingContextValue = {
    isLoading: boolean;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LoadingContext = React.createContext<LoadingContextValue>({ isLoading: true, setLoading: () => {}})

export function LoadingProvider({children}: LoadingProviderProps){
  const [isLoading, setLoading] = useState(false)
  return <LoadingContext.Provider value={{isLoading, setLoading}}>
    {children}
  </LoadingContext.Provider>
}

export function LoadingContainer({ altText, children }: LoadingSpinnerProps) {
    const {isLoading} = useContext(LoadingContext)

    const { t } = useTranslation()

    return (
      <>
        <span aria-hidden={!isLoading} style={{display: isLoading ? "contents" : "none"}}><Spinner altText={altText || t('loading_spinner', 'Loading...')}/></span>
        <span aria-busy={isLoading} style={{display: isLoading ? "none" : "contents"}}>{ children }</span>
      </>
    );
}

export function LoadingSpinner(props: LoadingSpinnerProps) {
  return (
    <LoadingProvider>
      <LoadingContainer {...props} />
    </LoadingProvider>
  )
}

export function Spinner({altText}) {
    return <img className="spinner" src={spinner} alt={altText} />
}
